/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { g as getNative } from './isLength-dd14023c.js';

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

export { defineProperty as d };

//# sourceMappingURL=_defineProperty-f2b25ce4.js.map